import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import { Observable }     from 'rxjs/Observable';
import { UtilitiesService } from '../services/utilities.service';

@Injectable()
export class SubirArticulosService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService
  ) {  }  

   public insert(arr: any) {
    let json = { "Metodo": "SubirArticulos", "Datos": arr };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).timeout(60000).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/subir-articulos.service.ts